export default defineNuxtPlugin((_) => {
  if (import.meta.server) {
    return
  }

  const originalFetch = window.fetch
  window.fetch = async (input, init = {}) => {
    const { $iproToken, $iproAuthenticated } = useNuxtApp()

    const url = input instanceof Request ? input.url : input as string

    if ($iproAuthenticated.value && $iproToken.value && (url.startsWith('/') || url.startsWith(window.location.origin))) {
      const headers = new Headers(init.headers || {})
      headers.set('Authorization', `Bearer ${$iproToken.value}`)
      init.headers = headers
    }

    return await originalFetch(input, init)
  }
})
